module.exports = "https://cdn.dove.it/_next/static/public/assets/services/fotografie_430.aaebe9088bf5cc80a1f78aab97002ae1.jpg";